/** English fallback for the WhatsApp integration; wired up in lib/i18n/en.ts. */
export const whatsAppEs = {
  qr: {
    contactMismatch: 'El número de teléfono no pertenece al cliente o contacto seleccionado.',
    history: 'Mensaje de WhatsApp',
    accessDenied:
      'La conexión de WhatsApp no está activada en este servidor o no tiene los permisos necesarios.',
    sendFailed:
      'No pudo confirmarse el envío del mensaje. Compruebe su estado y la conexión antes de reenviarlo.',
    documentCustomerMismatch: 'El documento no pertenece al cliente de esta conversación.',
    templatesUnavailable: 'Las plantillas Cloud no están disponibles para WhatsApp (Baileys).',
    provider: 'WhatsApp (Baileys)',
    providerField: 'Proveedor de conexión',
    cloudProvider: 'WhatsApp Business Cloud API',
    label: 'Conexión no oficial mediante Baileys',
    help: 'Ayuda de WhatsApp',
    setup:
      'Vincule su cuenta WhatsApp mediante QR. Los textos para contactos ERP conocidos aparecen aunque la conversación comience en el móvil; también se importan respuestas y mensajes recibidos durante una interrupción.',
    loadError: 'No se pudo cargar el estado de conexión.',
    connect: 'Conectar número',
    reconnect: 'Restablecer conexión',
    logout: 'Cerrar sesión',
    qrAlt: 'Código QR para vincular WhatsApp',
    scan: 'Abra WhatsApp en su teléfono → Dispositivos vinculados → Vincular un dispositivo y escanee este código QR.',
    expires: 'Código QR válido hasta {{time}}.',
    expired: 'El código QR ha caducado. Restablezca la conexión para obtener otro código.',
    connectionError:
      'La conexión se interrumpió o no pudo establecerse. Restablézcala para volver a intentarlo.',
    actionError: 'La acción falló. Compruebe su autorización en el servidor y vuelva a intentarlo.',
    limits:
      'El envío individual requiere una acción explícita del usuario. No se importan historiales privados ni la libreta de contactos. El modo de introducción, los consentimientos y las restricciones de contacto siguen vigentes.',
    logoutTitle: '¿Cerrar la sesión del número de WhatsApp?',
    logoutDescription:
      'Se desconectará {{phone}} y se eliminará la sesión guardada. Para una nueva conexión será necesario volver a escanear el código QR.',
    logoutConfirm: 'Cerrar sesión del número y eliminar la sesión',
    pdfHint:
      'El documento se envía directamente como PDF mediante WhatsApp (Baileys). Aquí no se aplican las plantillas Cloud ni la ventana de 24 horas.',
    pdfSend: 'Enviar PDF mediante WhatsApp',
    accepted:
      'El envío se ha aceptado. El estado de entrega se actualiza según los eventos reales de WhatsApp.',
    status: {
      DISCONNECTED: 'Sin conexión',
      CONNECTING: 'Conectando',
      QR_READY: 'Código QR listo para escanear',
      CONNECTED: 'Conectado',
      EXPIRED: 'Código QR caducado',
      ERROR: 'Error de conexión',
    },
  },
  inbox: {
    title: 'Bandeja de entrada del equipo de WhatsApp',
    subtitle: 'Mensajes a clientes y documentos PDF mediante la conexión de WhatsApp disponible.',
    search: 'Buscar por nombre, número o mensaje',
    empty: 'No hay conversaciones en esta vista.',
    error: 'No se pudieron cargar las conversaciones.',
    selectHint: 'Selecciona una conversación a la izquierda.',
  },
  scope: {
    ALL: 'Todos',
    MINE: 'Mías',
    UNASSIGNED: 'No asignado',
    CLOSED: 'Cerradas',
  },
  conversationStatus: {
    OPEN: 'Abierto',
    PENDING: 'Pendiente',
    RESOLVED: 'Resuelto',
    ARCHIVED: 'Archivado',
  },
  status: {
    PENDING: 'Enviando',
    SENT: 'Enviado',
    DELIVERED: 'Entregado',
    READ: 'Leer',
    FAILED: 'Fallido',
  },
  templateStatus: {
    APPROVED: 'Aprobado',
    PENDING: 'En revisión',
    REJECTED: 'Rechazado',
    PAUSED: 'Pausado',
    DISABLED: 'Deshabilitado',
  },
  category: {
    MARKETING: 'Marketing',
    UTILITY: 'Utilidad',
    AUTHENTICATION: 'Autenticación',
  },
  optIn: {
    OPTED_IN: 'Consentimiento en el archivo',
    OPTED_OUT: 'Objeción registrada',
    PENDING: 'Solicitud pendiente',
    NOT_REQUESTED: 'Aún no solicitada',
  },
  window: {
    open: 'Ventana abierta · {{hours}} h {{minutes}} min',
    openShort: 'Ventana abierta ({{hours}} h {{minutes}} min)',
    closed: 'Solo plantillas',
    closedShort: 'Ventana cerrada — solo plantillas',
  },
  chat: {
    unknownCustomer: 'Ningún cliente vinculado',
    openCustomer: 'Perfil del cliente',
    assignee: 'Asignado a',
    unassigned: 'No asignado',
    status: 'Estado',
    empty: 'Todavía no hay mensajes en esta conversación.',
    error: 'No se pudo cargar el historial de mensajes.',
    placeholder: 'Escribir un mensaje … (Enter para enviar, Shift+Enter para una nueva línea)',
    send: 'Enviar',
    emoji: 'Insertar emoji',
    attachDocument: 'Adjuntar documento',
    useTemplate: 'Usar plantilla',
    download: 'Descargar',
    attachment: 'Adjunto',
    templateLabel: 'Plantilla: {{name}}',
    windowClosed:
      'La ventana de 24 h ha expirado. Envía una plantilla para reabrir la conversación.',
    chooseTemplate: 'Elegir plantilla',
  },
  sidebar: {
    title: 'Archivo del cliente',
    placeholder: 'Selecciona una conversación para ver los detalles del cliente.',
    noCustomer: 'Este número no está vinculado a un cliente.',
    contact: 'Contacto: {{name}}',
    optIn: 'Confirmado el consentimiento de WhatsApp',
    optInSaved: 'Consentimiento guardado.',
    openDocuments: 'Abrir documentos',
    noDocuments: 'No hay documentos abiertos.',
    documentsError: 'No se pudieron cargar los documentos.',
  },
  templates: {
    pickTitle: 'Enviar plantilla',
    pickDescription:
      'Solo las plantillas aprobadas por Meta pueden enviarse fuera de la ventana de 24 horas.',
    template: 'Plantilla',
    choose: 'Elegir plantilla',
    placeholder: 'Marcador de posición {{position}}',
    preview: 'Vista previa',
    pdfHeader: 'Documento PDF como encabezado',
    send: 'Enviar plantilla',
    sent: 'La plantilla ha sido enviada.',
    error: 'No se pudieron cargar las plantillas.',
    emptyApproved: 'No hay ninguna plantilla aprobada disponible.',
  },
  document: {
    title: 'Adjuntar documento',
    description: 'El documento se envía como PDF a la conversación actual.',
    document: 'Documento',
    choose: 'Elegir documento',
    caption: 'Subtítulo',
    captionPlaceholder: 'Texto opcional para el archivo adjunto',
    send: 'Enviar documento',
    sent: 'El documento ha sido enviado.',
    empty: 'No hay documento para este cliente.',
    error: 'No se pudieron cargar los documentos.',
  },
  documentSend: {
    chooseConversation: 'Elegir una conversación',
    action: 'Enviar vía WhatsApp',
    title: 'Enviar documento vía WhatsApp',
    description: 'Entregar documento {{number}} a {{customer}}.',
    noConversation: 'Aún no hay conversación para este cliente.',
    createChat: 'Crear conversación',
    windowOpenHint:
      'La ventana de servicio está abierta; la plantilla entrega el documento con su PDF.',
    windowClosedHint:
      'La ventana de servicio está cerrada. La entrega utiliza una plantilla aprobada.',
    chooseTemplate: 'Elige plantilla y enviar',
  },
  customerTab: {
    subtitle:
      'Conversaciones de WhatsApp guardadas para este cliente. Solo se muestran las cuentas que tiene asignadas.',
    start: 'Nueva conversación',
    startTitle: 'Iniciar una conversación de WhatsApp',
    startDescription: 'El número se normaliza automáticamente a E.164.',
    started: 'La conversación ha sido creada.',
    phone: 'Número de móvil',
    empty: 'Aún no hay conversación de WhatsApp para este cliente.',
    error: 'No se pudieron cargar las conversaciones.',
    noAccess: 'No tiene permisos para ver el historial de WhatsApp.',
  },
  config: {
    title: 'Configuración de WhatsApp',
    subtitle: 'Administrar las conexiones de WhatsApp y las plantillas Cloud.',
    error: 'No se pudo cargar la configuración.',
    tabConnection: 'WhatsApp Business Cloud API',
    tabTemplates: 'Plantillas Cloud',
    credentials: 'Meta Graph API',
    credentialsHint:
      'Estos valores provienen del panel de desarrolladores de Meta. Los secretos se almacenan cifrados y nunca se devuelven.',
    phoneNumberId: 'ID de número de teléfono',
    wabaId: 'ID de cuenta de empresa de WhatsApp',
    appId: 'ID de la aplicación',
    businessPhoneNumber: 'Número del remitente (E.164)',
    displayName: 'Nombre para mostrar',
    accessToken: 'Token de acceso permanente',
    appSecret: 'Secreto de la aplicación',
    secretPlaceholder: 'Rellénelo solo para reemplazar el valor',
    secretSet: 'Almacenado ({{hint}})',
    secretMissing: 'Aún no almacenado',
    rotateToken: 'Generar un nuevo token de verificación',
    rotateTokenHint: 'Requiere configurar el webhook nuevamente en el panel de Meta.',
    saved: 'La configuración se ha guardado.',
    test: 'Probar conexión',
    verifiedName: 'Nombre verificado',
    displayNumber: 'Número de visualización',
    quality: 'Calidad',
    limit: 'Límite de mensajes',
    checkedAt: 'Revisado en {{timestamp}}',
    webhook: 'Configuración del webhook',
    webhookHint:
      'Ingrese estos valores en "Webhooks" en el panel de desarrolladores de Meta y suscríbase al campo "messages".',
    callbackUrl: 'URL de callback',
    verifyToken: 'Token de verificación',
    copy: 'Copiar',
    copied: 'Copiado al portapapeles.',
    lastWebhook: 'Última entrega: {{timestamp}}',
    noWebhookYet: 'Aún no se ha recibido ninguna entrega.',
    templates: 'Plantillas de Meta',
    templatesHint: 'El espejo local se actualiza completamente en cada sincronización.',
    templatesEmpty: 'Aún no se han sincronizado plantillas.',
    sync: 'Sincronizar plantillas',
    syncDone: 'Plantillas {{fetched}} obtenidas · {{created}} nuevas · {{updated}} actualizadas.',
    templateName: 'Nombre',
    language: 'Idioma',
    category: 'Categoría',
    status: 'Estado',
    templatePreview: 'Vista previa con marcadores de posición de ERP',
  },
  accounts: {
    unavailableMember: 'Empleado que ya no está disponible ({{id}})',
    unavailableHelp:
      'Estas asignaciones guardadas corresponden a empleados que ya no están disponibles. Elimínelas explícitamente si deben revocarse. No se elimina automáticamente ninguna asignación.',

    title: 'Cuentas de WhatsApp',
    description:
      'Cada cuenta tiene su propia conexión. Solo los empleados asignados pueden ver sus conversaciones y código QR.',
    select: 'Cuenta de WhatsApp',
    choose: 'Elegir una cuenta',
    all: 'Todas las cuentas asignadas',
    empty: 'No tiene ninguna cuenta de WhatsApp asignada.',
    error: 'No se pudieron cargar las cuentas de WhatsApp.',
    new: 'Añadir cuenta',
    edit: 'Editar cuenta',
    label: 'Nombre de la cuenta',
    members: 'Empleados asignados',
    noMembers: 'Sin empleados asignados, nadie puede utilizar esta cuenta.',
    manageEmpty: 'Todavía no se ha añadido ninguna cuenta de WhatsApp.',
    saved: 'Se ha guardado la cuenta de WhatsApp.',
    saveError: 'No se pudo guardar la cuenta. Revise los datos e inténtelo de nuevo.',
    rescan: 'Se perdió la vinculación. Escanee un nuevo código QR.',
    membersError: 'No se pudieron cargar los empleados.',
    invalid: 'Revise el nombre de la cuenta y la selección de empleados.',
  },
  history: {
    connect: 'Conectar y cargar historial',
    connectTitle: '¿Vincular {{account}} con historial de texto?',
    connectDescription:
      'Elija esta acción antes del primer escaneo QR para solicitar el historial de texto disponible durante la vinculación. No se cierra automáticamente ninguna vinculación existente.',
    connectConfirm: 'Vincular con historial de texto',
    pairingRequired:
      'Esta vinculación no tiene mensajes ERP adecuados como punto de partida. Cierre deliberadamente la sesión de la cuenta y elija «Conectar y cargar historial» antes de escanear el nuevo código QR. Una reconexión normal no recupera este historial.',

    action: 'Solicitar historial',
    title: '¿Solicitar historial de {{account}}?',
    description:
      'Solicita los textos disponibles del dispositivo vinculado. Solo se importan clientes y contactos ERP conocidos o conversaciones asignadas expresamente a esta cuenta. Los mensajes antiguos se cargan por lotes: hasta 200 conversaciones, 1.000 mensajes por conversación y diez minutos por solicitud. Repita la solicitud para historiales más largos. WhatsApp determina la disponibilidad; no se garantiza una importación completa.',
    confirm: 'Solicitar historial ahora',
    pending: 'Solicitando historial …',
    requested:
      'Se ha enviado la solicitud. Los mensajes de texto disponibles de contactos conocidos del ERP aparecerán después del procesamiento.',
    unavailable: 'El dispositivo vinculado no proporciona historial en este momento.',
    error: 'No se pudo solicitar el historial. Compruebe la conexión e inténtelo de nuevo.',
  },
  phone: {
    change: 'Cambiar número',
    changeTitle: 'Cambiar el número de WhatsApp',
    changeDescription:
      'El nuevo número tendrá una conversación separada en la cuenta de WhatsApp elegida. El historial existente se conserva. Los datos del cliente no se modifican automáticamente.',
    useNumber: 'Usar el nuevo número',

    existing: 'Número existente',
    choose: 'Elegir un número de cliente o contacto',
    invalid: 'Introduzca un número de móvil válido, por ejemplo 0170 1234567 o +49 170 1234567.',
    loadError: 'No se pudieron cargar los números de teléfono existentes.',
    source: {
      CUSTOMER: 'Número del cliente',
      CONTACT_MOBILE: 'Contacto: móvil',
      CONTACT_PHONE: 'Contacto: teléfono',
    },
  },
  baileysTemplates: {
    title: 'Plantillas locales de WhatsApp',
    description:
      'Textos reutilizables para cuentas Baileys. Las plantillas locales no requieren aprobación de Meta y respetan las preferencias de contacto habituales.',
    create: 'Añadir plantilla local',
    edit: 'Editar plantilla local',
    delete: 'Eliminar plantilla local',
    confirmDeleteTitle: '¿Eliminar {{name}}?',
    confirmDeleteDescription:
      'Esta plantilla local dejará de estar disponible para mensajes nuevos. Se conservarán los mensajes existentes.',
    empty: 'Todavía no se han añadido plantillas locales.',
    loadError: 'No se pudieron cargar las plantillas locales.',
    name: 'Nombre de la plantilla',
    language: 'Idioma',
    body: 'Texto del mensaje',
    bodyHelp:
      'Use marcadores numerados como {{example}}. Empiece por 1 sin saltos; como máximo 50 marcadores diferentes y 4096 caracteres.',
    variableMapping: 'Valores ERP opcionales',
    mappingSource: 'Origen del valor {{position}}',
    mappingLabel: 'Etiqueta del campo {{position}}',
    noMapping: 'Introducir manualmente',
    transactionalOnly:
      'Para mensajes transaccionales. La publicidad requiere el proceso de marketing separado con consentimiento documentado.',
    saved: 'Se guardó la plantilla local.',
    deleted: 'Se eliminó la plantilla local.',
    versionConflict:
      'Otra persona ha modificado esta plantilla. Vuelva a cargarla antes de guardar o enviar.',
    duplicateName: 'Ya existe una plantilla local con este nombre e idioma.',
    invalidPlaceholders:
      'Use únicamente marcadores numerados del 1 al 50 sin saltos, como {{example}}.',
    invalidMapping: 'Asigne cada valor ERP una sola vez y únicamente a un marcador existente.',
    invalidParameters:
      'Rellene cada marcador exactamente una vez con un valor válido. Compruebe la longitud del mensaje.',
    invalidName: 'Introduzca un nombre de plantilla de hasta 120 caracteres.',
    invalidLanguage: 'Seleccione un idioma compatible.',
    invalidBody: 'Introduzca un mensaje de hasta 4096 caracteres.',
    validationSummary: 'No se pudo guardar la plantilla. Revise los campos señalados.',
    discardTitle: '¿Descartar los cambios?',
    discardDescription: 'Se perderán los cambios sin guardar de esta plantilla.',
    discard: 'Descartar cambios',
    pickTitle: 'Enviar una plantilla local de WhatsApp',
    pickDescription:
      'Compruebe el texto y todos los valores antes de enviar desde la cuenta Baileys seleccionada.',
    choose: 'Elegir plantilla local',
    send: 'Enviar mensaje',
    preview: 'Vista previa del mensaje',
    pdfAttachment: 'PDF adjunto',
    search: 'Buscar plantillas locales',
    page: 'Página {{page}} de {{pages}}',
    captionTooLong: 'Un mensaje que acompaña a un PDF puede contener hasta 1024 caracteres.',
    sources: {
      'customer.name': 'Nombre del cliente',
      'customer.number': 'Número del cliente',
      'contact.firstName': 'Nombre del contacto',
      'document.number': 'Número del documento',
      'document.date': 'Fecha del documento',
      'document.dueDate': 'Fecha de vencimiento',
      'document.grossTotal': 'Importe total',
      'document.currency': 'Moneda',
      'tenant.name': 'Nombre de la empresa',
      'user.name': 'Nombre del empleado',
      custom: 'Valor manual',
    },
  },
};
